import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { EdgeDevice, EdgeDeviceItemsResult, GridRequestQuery } from '@api/index';
import { Navigate } from '@ngxs/router-plugin';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { map } from 'rxjs';
import { ComponentBaseDirective } from '../component.base';

@Component({
    selector: 'app-edge-device-list',
    templateUrl: './edge-device-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EdgeDeviceListComponent extends ComponentBaseDirective {
    @Input() public edgeDevices: EdgeDeviceItemsResult;
    @Output() public selectionChange = new EventEmitter<EdgeDevice>();
    @Output() public selectionEdit = new EventEmitter<EdgeDevice>();
    @Output() public gridRequestEvent = new EventEmitter<GridRequestQuery>();

    public columns$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            const columns = [
                { $$id: 'deviceStatus', width: 30, maxWidth: 30, sortable: false, resizeable: false, cellTemplate: this.deviceStatusTemplate, canAutoResize: false },
                { name: this.translationService.translate('defaults.name'), prop: 'name', resizeable: false, canAutoResize: true },
                { name: this.translationService.translate('devices.serialNumber'), prop: 'serialNumber', resizeable: false, canAutoResize: true },
                { $$id: 'remoteSupport', width: 50, maxWidth: 50, sortable: false, resizeable: false, cellTemplate: this.remoteSupportTemplate, canAutoResize: false },
                { $$id: 'commands', width: 50, maxWidth: 50, sortable: false, resizeable: false, cellTemplate: this.commandsTemplate, canAutoResize: false },
            ] as TableColumn[];

            return columns;
        })
    );
    public SelectionType = SelectionType;

    @ViewChild('deviceStatusTemplate', { static: true }) private deviceStatusTemplate: TemplateRef<string>;
    @ViewChild('remoteSupportTemplate', { static: true }) private remoteSupportTemplate: TemplateRef<string>;
    @ViewChild('commandsTemplate', { static: true }) private commandsTemplate: TemplateRef<string>;

    constructor() {
        super();
    }

    public emitSelect([edgeDevice]: EdgeDevice[]) {
        this.selectionChange.emit(edgeDevice);
    }

    public emitEdit(edgeDevice: EdgeDevice) {
        this.selectionEdit.emit(edgeDevice);
    }

    public provisionEdgeDevice() {
        this.store.dispatch(new Navigate(['/device/register']));
    }

    public gridRequested(gridRequestQuery: GridRequestQuery) {
        this.gridRequestEvent.emit(gridRequestQuery);
    }
}
